import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemUnknown extends Item {
    /**
     * @param {string} id
     */
    constructor(id) {
        super(id, texture("prop_blue_flowers_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}